import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { CtaBand } from "@/components/site/Sections";
import { MARKETS } from "@/components/site/data";

export default function Markets() {
  return (
    <>
      <PageHero overline="Our Markets" title="One Sourcing Relationship. Multiple Market Opportunities.">
        <p>
          Products with genuine international potential should not necessarily be restricted to a
          single market.
        </p>
        <p>
          RSC Imports' multi-market structure allows suitable sourcing opportunities to be assessed
          across the Middle East, India and Southeast Asia.
        </p>
      </PageHero>

      {MARKETS.map((m, i) => (
        <section
          key={m.name}
          data-testid={`market-section-${m.region.toLowerCase().replace(/\s+/g, "-")}`}
          className={`py-20 md:py-28 ${i % 2 === 1 ? "bg-white" : ""}`}
        >
          <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
            <Reveal className={`lg:col-span-5 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
              <div className="relative overflow-hidden">
                <img src={m.image} alt={m.name} className="w-full h-[320px] md:h-[440px] object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A1F16]/45 to-transparent" />
                <p className="absolute bottom-5 left-6 text-xs uppercase tracking-[0.25em] text-[#FBF9F6] font-semibold">
                  {m.num} — {m.region}
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.15} className={`lg:col-span-7 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
              <p className="text-xs uppercase tracking-[0.25em] text-[#BFA26F] font-semibold mb-4">{m.footer}</p>
              <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-medium leading-tight text-[#111413]">
                {m.name}
              </h2>
              <div className="mt-6 h-px w-24 bg-[#BFA26F]" />
              <p className="mt-8 text-base md:text-lg font-light text-[#4A5D54] leading-relaxed max-w-2xl">
                {m.text}
              </p>
              <p className="mt-10 text-xs uppercase tracking-[0.25em] text-[#0D2B1E] font-semibold">
                Potential Channels
              </p>
              <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-x-8" data-testid={`market-channels-${m.region.toLowerCase().replace(/\s+/g, "-")}`}>
                {m.channels.map((c) => (
                  <li
                    key={c}
                    className="py-3 border-b border-[#0D2B1E]/10 text-sm font-light text-[#4A5D54] flex items-start gap-3"
                  >
                    <span className="mt-2 h-px w-4 bg-[#BFA26F] shrink-0" />
                    {c}
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
        </section>
      ))}

      <CtaBand
        title="Access Three Consumer Regions."
        text="A single sourcing relationship with RSC Imports can open multiple market opportunities."
        buttonLabel="Become a Supplier"
        to="/partner"
      />
    </>
  );
}
